var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../../Base.js";
import DomHelper from "../../helper/DomHelper.js";
import ObjectHelper from "../../helper/ObjectHelper.js";
var Labelable_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    get hasLabel() {
      return Boolean(this.label);
    }
    compose() {
      const { hasLabel, labelPosition } = this;
      return {
        class: {
          [`b-label-${labelPosition}`]: hasLabel,
          "b-has-label": hasLabel
        }
      };
    }
    changeLabel(label) {
      return label || "";
    }
    setupLabel(lbl) {
      return ObjectHelper.assign({
        tag: "label",
        for: `${this.id}-input`,
        class: `b-label b-align-${lbl.align || "start"}`
      }, lbl);
    }
    updateLabelWidth(newValue) {
      if (this.labelElement) {
        this.labelElement.style.flex = `0 0 ${DomHelper.setLength(newValue)}`;
        this.inputWrap.style.flexBasis = newValue == null ? "" : "auto";
      }
    }
    //endregion
    // This does not need a className on Widgets.
    // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
    // to the Widget it's mixed in to should implement this.
    get widgetClass() {
    }
  }, //region Config
  __publicField(_a, "$name", "Labelable"), __publicField(_a, "configurable", {
    /**
     * Get/set fields label. Please note that the Field needs to have a label specified from start for this to
     * work, otherwise no element is created.
     * @member {String} label
     */
    /**
     * Label, prepended to field
     * @config {String}
     * @category Label
     */
    label: null,
    /**
     * Label position, either 'before' the field or 'above' the field
     * @config {'before'|'above'}
     * @default
     * @category Label
     */
    labelPosition: "before",
    /**
     * CSS class name or class names to add to any configured {@link #config-label}
     * @config {String|Object}
     * @category Label
     */
    labelCls: null,
    /**
     * The width to apply to the `<label>` element. If a number is specified, `px` will be used.
     * @config {String|Number}
     * @localizable
     * @category Label
     */
    labelWidth: {
      value: null,
      $config: {
        localeKey: "L{labelWidth}"
      }
    }
  }), _a;
};
export {
  Labelable_default as default
};
